import { EstablishmentCardComponent } from './shared/components/establishment-card/establishment-card.component';
import { SearchComponent } from './shared/components/search/search.component';
import { MenuComponent } from './shared/components/menu/menu.component';
import { BurgerMenuComponent } from './shared/components/burger-menu/burger-menu.component';
import { LogoComponent } from './shared/components/logo/logo.component';
import { HeaderBarComponent } from './shared/components/header-bar/header-bar.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { MainComponent } from './main/main.component';
import { CookieService } from './shared/services/cookie.service';
import { OrganizationModel } from './shared/models/organization-model';
import { OrganizationService } from './shared/services/organization.service';
import { AddressModel } from './shared/models/address-model';
import { GeocoderService } from './shared/services/geocoder.service';
import { ContactService } from './shared/services/contact.service';
import { FileService } from './shared/services/file.service';
import { TokenService } from './shared/services/token.service';
import { TrainingModel } from './shared/models/training-model';
import { TrainingService } from './shared/services/training.service';
import { NewsService } from './shared/services/news.service';
import { NewsModel } from './shared/models/news-model';
import { DataService } from './shared/services/data.service';
import { LearningOfferModel } from './shared/models/learning-offer-model';
import { LearningOfferService } from './shared/services/learning-offer.service';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './shared/modules/material.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { Overlay } from '@angular/cdk/overlay';
import { S3Service } from './shared/services/s3.service';


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    FooterComponent,
    HeaderBarComponent,
    LogoComponent,
    BurgerMenuComponent,
    MenuComponent,
    SearchComponent,
    EstablishmentCardComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule
  ],
  providers: [
    LearningOfferService,
    LearningOfferModel,
    DataService,
    NewsModel,
    NewsService,
    TrainingService,
    TrainingModel,
    TokenService,
    FileService,
    ContactService,
    GeocoderService,
    AddressModel,
    OrganizationService,
    OrganizationModel,
    CookieService,
    Overlay,
    S3Service
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
